<template>
    <div>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <strong>Создание аптеки</strong>
                    </CCardHeader>

                    <CCardBody>
                        <PharmacyUpsertForm @success="$router.push('/pharmacies')" @dismiss="$router.go(-1)" />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import PharmacyUpsertForm from '@/components/pharmacies/PharmacyUpsertForm'

    export default {
        name: 'PharmacyCreate',

        components: {
            PharmacyUpsertForm,
        },
    }
</script>

<style>

</style>